import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'yes-no-question',
  templateUrl: 'yes-no-question.html',
  styleUrls: ['yes-no-question.scss'],
})
export class YesNoQuestionComponent {

  @Input()
  public title: string;

  @Input()
  public description: string;

  @Input()
  public value: 'true' | 'false';

  @Output()
  public valueChange: EventEmitter<string> = new EventEmitter<string>();

  @Input()
  public valueOnly: boolean = false;

  public valueChanged(): void {
    this.valueChange.emit(this.value);
  }

}
